import { axios, Response } from '../index'

export const desativateTags = (
  tagsForDesativateIds: number[]
): Response<void> => {
  return axios.delete(`/v1/tags/${tagsForDesativateIds}`)
}
